import { motion, AnimatePresence } from 'framer-motion';
import { X, Target } from 'lucide-react';

interface PositionnementModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PositionnementModal({ isOpen, onClose }: PositionnementModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-emerald-500/30 shadow-2xl shadow-emerald-500/20"
          >
            <div className="relative p-8 border-b border-emerald-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-emerald-500 to-green-500 rounded-xl">
                    <Target className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-400">
                      Positionnement - 100% Clients
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Promesse officielle</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-emerald-600/20 via-green-600/20 to-emerald-600/20 rounded-xl p-8 border-2 border-emerald-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Notre Promesse</h3>
                <p className="text-gray-300 text-center text-2xl font-bold text-emerald-400 mb-4">
                  100% des clients font plus de cash
                </p>
                <p className="text-gray-300 text-center text-lg">
                  Grâce à l'IA intégrée dans nos solutions.
                </p>
              </div>
              <div className="bg-gradient-to-br from-emerald-500/10 to-green-500/10 rounded-xl p-6 border border-emerald-500/30">
                <h4 className="text-xl font-bold text-white mb-4">KPI : % mandats avec ROI</h4>
                <p className="text-gray-300">Pourcentage de mandats avec ROI mesurable et documenté.</p>
              </div>
            </div>
            <div className="p-6 border-t border-emerald-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-emerald-500 to-green-500 text-white rounded-xl hover:from-emerald-600 hover:to-green-600 transition-all duration-200 font-semibold shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

